<template>
  <div
    class="burger-menu-button"
    :class="{ 'is-active': isOpen }"
    @click="toggleMenu"
    :aria-label="isOpen ? 'Close menu' : 'Open menu'"
    role="button"
    tabindex="0"
    @keydown.enter="toggleMenu"
    @keydown.space="toggleMenu"
  >
    <div class="burger-lines">
      <span class="line line-1"></span>
      <span class="line line-2"></span>
      <span class="line line-3"></span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isOpen?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  toggle: [];
}>();

const toggleMenu = () => {
  emit('toggle');
};
</script>

<style scoped>
.burger-menu-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  outline: none;
  position: relative;
  z-index: 10;
}

.burger-menu-button:hover {
  /* background: var(--ion-input-background-animation-hover); */
  transform: scale(1.05);
}

.burger-lines {
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.line {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--ion-color-primary);
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

/* Animation states */
.burger-menu-button.is-active .line-1 {
  transform: translateY(8px) rotate(45deg);
}

.burger-menu-button.is-active .line-2 {
  opacity: 0;
  transform: scaleX(0);
}

.burger-menu-button.is-active .line-3 {
  transform: translateY(-8px) rotate(-45deg);
}

/* Hover effects */
.burger-menu-button:hover:not(.is-active) .line {
  background: var(--ion-color-primary-shade);
}

.burger-menu-button:hover:not(.is-active) .line-1 {
  transform: translateX(2px);
}

.burger-menu-button:hover:not(.is-active) .line-2 {
  transform: scaleX(0.8);
}

.burger-menu-button:hover:not(.is-active) .line-3 {
  transform: translateX(2px);
}

/* Active state colors */
/* .burger-menu-button.is-active .line {
  background: var(--ion-color-primary);
} */

/* Focus styles */
/* .burger-menu-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--ion-color-primary-tint);
} */

/* Mobile optimizations */
@media (max-width: 768px) {
  .burger-menu-button {
    width: 36px;
    height: 36px;
  }

  .burger-lines {
    width: 20px;
    height: 16px;
  }

  .line {
    height: 2px;
  }

  .burger-menu-button.is-active .line-1 {
    transform: translateY(7px) rotate(45deg);
  }

  .burger-menu-button.is-active .line-3 {
    transform: translateY(-7px) rotate(-45deg);
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .line {
    background: var(--ion-color-dark);
  }

  .burger-menu-button:hover {
    background: var(--ion-color-light);
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .burger-menu-button,
  .line {
    transition: none;
  }
}
</style>
